import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { Button, Card, Col, Container, Form, Modal, Row } from 'react-bootstrap'
import { DayPicker } from 'react-day-picker'
import 'react-day-picker/dist/style.css'
import { useNavigate, useParams } from 'react-router-dom'
import countryList from 'react-select-country-list'
import { downloadSurveyPdf } from '../helpers/surveyPdf'
import KAccess from '../components/KAccess'
import KButton from '../components/KButton'
import KLayerNavigation from '../components/KLayerNavigation'
import KycCkecks from '../components/KycChecks'
import {
  canEditKycForms,
  formatDDMMYYYY,
  getAccessToken,
  getCompanyInfo,
  getDataSecurityCompanyName,
  isPiiEncryptionEnabled,
  isUserLoggedIn,
  parseDDMMYYYY,
  setAccessToken,
  setUserAccess,
  showKAlert,
} from '../helpers'
import { getKycCheckVariant } from '../helpers/stammdaten.helper'
import { downloadKycFile } from '../helpers/downloadKycFile'
import { t } from '../locale'
import { BeneficialOwner, Client, ClientInfo, RepresentativeNaturalPerson } from '../react-app-env'
import {
  clearKycCheckCache,
  createIdentityRequestService,
  deleteIdentityRequestService,
  fetchAccess,
  fetchClientById,
  fetchIdentityParams,
  getKycCheckClientInfo,
  performKycCheckOne,
  validatePinCode,
} from '../service/client'
import {
  addBeneficialOwner,
  addRepresentative,
  deleteBeneficialOwner,
  deleteRepresentative,
  getClientInfo,
  updateBeneficialOwner,
  updateClientInfo,
  updateRepresentative,
} from '../service/clientInfo'
import IdentityModal from '../components/KModal'

const PICKER_DROPDOWN_STYLE: React.CSSProperties = {
  position: 'absolute',
  zIndex: 1000,
  background: 'white',
  boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
  borderRadius: 8,
  padding: 8,
}

export default function SurveyFormPerson() {
  const navigate = useNavigate()
  const { clientId } = useParams()

  const canEdit = canEditKycForms()
  const surveyPdfRef = useRef<HTMLFieldSetElement>(null)

  const [client, setClient] = useState<Client | null>(null)
  const [clientInfo, setClientInfo] = useState<ClientInfo | null>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [showModal, setShowModal] = useState(false)
  const [showModalIdentity, setShowModalIdentity] = useState(false)
  const [identitySubjectId, setIdentitySubjectId] = useState<string>('')
  const [identitySubjectType, setIdentitySubjectType] = useState<
    'client' | 'representative' | 'beneficialOwner'
  >('client')
  const [identityRequests, setIdentityRequests] = useState<Record<string, any>>({})
  const [variantIdentity, setVariantIdentity] = useState<
    Record<string, 'secondary' | 'success' | 'warning' | 'danger'>
  >({})

  const [kycChecksNew, setKycChecksNew] = useState(false)
  const [kycChecks, setKycChecks] = useState([] as any[])
  const [pin, setPin] = useState('')
  const [access, setAccess] = useState(false)
  const [pinRequired, setPinRequired] = useState(true)
  const [formData, setFormData] = useState({
    id: '',
    dataCollected: false,
    newAssessment: false,
    name: '',
    firstName: '',
    legalForm: '',
    registerNumber: '',
    address: '',
    country: '',
    placeOfBirth: '',
    dateOfBirth: '',
    nationality: '',
    idNumber: '',
    authority: '',
    extractFromCommerical: false,
    foundingDocuments: false,
    ownDocumented: false,
    otherDocuments: false,
    idProof: false,
    electronicIdProof: false,
    otherProof: false,
    shareHolder: '',
    shareHolderFoundations: '',
    beneficialOwners: {
      type: null,
      legalEntities: {},
      foundationsLegalCapacity: {},
      instigationPersons: {},
      naturalPersonRoles: {
        admin: false,
        management_board: false,
        beneficiary: false,
        assets_distributed: false,
        other: false,
      },
    },
    noOneConnected: false,
    closeToPolitically: false,
    preciseDesignation: '',
    notEstablishedInHighRiskCountry: false,
    establishedInHighRiskCountry: false,
    thirdCountry: '',
    purposeAndNatureClear: false,
    purposeAndNatureDescription: false,
    purposeFurtherInfo: '',
    furtherInfo: '',
    idCardPassport: false,
    electronicIdentityProof: false,
    simplifiedDueDiligence: false,
    birthCertificateUnder16: false,
    guardianshipCertificate: false,
    authorizationVerifiedBy: '',
    isFinished: false,
  })

  const [datePickerDateOfBirth, setDatePickerDateOfBirth] = useState(false)
  const [datePickerRepresentativeBirthDate, setDatePickerRepresentativeBirthDate] = useState<
    Record<string, boolean>
  >({})
  const [datePickerBeneficialLegalBirthDate, setDatePickerBeneficialLegalBirthDate] = useState<
    Record<string, boolean>
  >({})
  const [dateOfBirthPickerMonth, setDateOfBirthPickerMonth] = useState<Date>(new Date(2000, 0))
  const [representativePickerMonth, setRepresentativePickerMonth] = useState<Record<string, Date>>(
    {}
  )
  const [beneficialPickerMonth, setBeneficialPickerMonth] = useState<Record<string, Date>>({})
  const [surveyFiles, setSurveyFiles] = useState<Array<{ name: string }>>([])
  const [surveyUploading, setSurveyUploading] = useState(false)
  const surveyFileInputRef = useRef<HTMLInputElement>(null)

  const representatives = clientInfo?.contractualPartner?.representatives || {}
  const beneficialOwnersLegalEntities = clientInfo?.beneficialOwners?.legalEntities || {}
  const hasRepresentatives = Object.keys(representatives).length > 0
  const hasBeneficialOwnersLegalEntities = Object.keys(beneficialOwnersLegalEntities).length > 0

  const countries = useMemo(
    () =>
      countryList()
        .getData()
        .sort((a, b) => t(a.label).localeCompare(t(b.label), 'de')),
    []
  )
  const saveTimeoutRef = useRef<NodeJS.Timeout | null>(null)

  useEffect(() => {
    const closeOnOutsideClick = (event: MouseEvent | TouchEvent) => {
      if ((event.target as HTMLElement).closest('.date-picker-wrapper')) return
      setDatePickerDateOfBirth(false)
      setDatePickerRepresentativeBirthDate({})
      setDatePickerBeneficialLegalBirthDate({})
    }

    document.addEventListener('mouseup', closeOnOutsideClick)
    document.addEventListener('touchend', closeOnOutsideClick)
    return () => {
      document.removeEventListener('mouseup', closeOnOutsideClick)
      document.removeEventListener('touchend', closeOnOutsideClick)
    }
  }, [])

  useEffect(() => {
    if (!clientId) return

    const fetchClientInfo = async () => {
      setLoading(true)
      setError(null)
      try {
        const response = await fetchClientById(clientId)
        setClient(response.client)

        const data = await getClientInfo(clientId)
        setClientInfo(data)

        if (data) {
          setFormData({
            id: data._id,
            dataCollected: data.dataCollected || false,
            newAssessment: data.newAssessment || false,
            name: data.name || '',
            firstName: data.firstName || '',
            country: data.country || '',
            placeOfBirth: data.placeOfBirth || '',
            dateOfBirth: data.dateOfBirth || '',
            nationality: data.nationality || '',
            idNumber: data.idNumber || '',
            authority: data.authority || '',
            legalForm: data.legalForm || '',
            registerNumber: data.registerNumber || '',
            address: data.address || '',
            extractFromCommerical: data.extractFromCommerical || false,
            foundingDocuments: data.foundingDocuments || false,
            ownDocumented: data.ownDocumented || false,
            otherDocuments: data.otherDocuments || false,
            idProof: data.idProof || false,
            electronicIdProof: data.electronicIdProof || false,
            otherProof: data.otherProof || false,
            shareHolder: data.shareHolder || '',
            shareHolderFoundations: data.shareHolderFoundations || '',
            beneficialOwners: {
              type: data.beneficialOwners?.type || null,
              legalEntities: data.beneficialOwners?.legalEntities || {},
              foundationsLegalCapacity: data.beneficialOwners?.foundationsLegalCapacity || {},
              instigationPersons: data.beneficialOwners?.instigationPersons || {},
              naturalPersonRoles: {
                admin: data.beneficialOwners?.naturalPersonRoles?.admin || false,
                management_board:
                  data.beneficialOwners?.naturalPersonRoles?.management_board || false,
                beneficiary: data.beneficialOwners?.naturalPersonRoles?.beneficiary || false,
                assets_distributed:
                  data.beneficialOwners?.naturalPersonRoles?.assets_distributed || false,
                other: data.beneficialOwners?.naturalPersonRoles?.other || false,
              },
            },
            noOneConnected: data.noOneConnected || false,
            closeToPolitically: data.closeToPolitically || false,
            preciseDesignation: data.preciseDesignation || '',
            notEstablishedInHighRiskCountry: data.notEstablishedInHighRiskCountry || false,
            establishedInHighRiskCountry: data.establishedInHighRiskCountry || false,
            thirdCountry: data.thirdCountry || '',
            purposeAndNatureClear: data.purposeAndNatureClear || false,
            purposeAndNatureDescription: data.purposeAndNatureDescription || false,
            purposeFurtherInfo: data.purposeFurtherInfo || '',
            furtherInfo: data.furtherInfo || '',
            idCardPassport: data.idCardPassport || false,
            electronicIdentityProof: data.electronicIdentityProof || false,
            simplifiedDueDiligence: data.simplifiedDueDiligence || false,
            birthCertificateUnder16: data.birthCertificateUnder16 || false,
            guardianshipCertificate: data.guardianshipCertificate || false,
            authorizationVerifiedBy: data.authorizationVerifiedBy || '',
            isFinished: data.isFinished || false,
          })
        }
      } catch (err: any) {
        setError(err.message || 'Failed to fetch client info')
        console.error(err)
      } finally {
        setLoading(false)
      }
    }

    fetchClientInfo()
  }, [clientId])

  const autoSave = useCallback(
    async (data: typeof formData) => {
      if (!canEdit) return
      if (!clientInfo?._id) return

      try {
        await updateClientInfo(clientInfo._id, data)
      } catch (err: any) {
        console.error('Auto-save failed:', err)
      }
    },
    [clientInfo, canEdit]
  )

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!canEdit) return
    const { name, value, type, checked } = e.target

    // Check if this is a naturalPersonRoles field
    const naturalPersonRoleFields = [
      'admin',
      'management_board',
      'beneficiary',
      'assets_distributed',
      'other',
    ]

    let updatedData: any
    if (naturalPersonRoleFields.includes(name)) {
      updatedData = {
        ...formData,
        beneficialOwners: {
          ...formData.beneficialOwners,
          naturalPersonRoles: {
            ...formData.beneficialOwners.naturalPersonRoles,
            [name]: checked,
          },
        },
      }
    } else {
      updatedData = {
        ...formData,
        [name]: type === 'checkbox' ? checked : value,
      }
    }

    setFormData(updatedData)

    if (saveTimeoutRef.current) {
      clearTimeout(saveTimeoutRef.current)
    }

    saveTimeoutRef.current = setTimeout(() => {
      autoSave(updatedData)
    }, 600)
  }

  // Once the form is marked finished, build a downloadable PDF that lists every
  // question and its current answer as flowing text (jsPDF never splits a line
  // across a page, so nothing gets cut mid-sentence).
  const handleGeneratePdf = () => {
    setDatePickerDateOfBirth(false)
    setDatePickerRepresentativeBirthDate({})
    setDatePickerBeneficialLegalBirthDate({})

    setTimeout(() => {
      if (!surveyPdfRef.current) return
      const fullName = [client?.firstName, client?.name].filter(Boolean).join(' ')
      downloadSurveyPdf(surveyPdfRef.current, {
        filename: `Erhebungsbogen_${client?.clientNumber ?? ''}`.replace(/\s+/g, '_'),
        heading: 'Erhebungsbogen',
        subheading: `${t('registerNumber')}: ${client?.clientNumber ?? '—'}${fullName ? '  ·  ' + fullName : ''}`,
      }).catch(err => console.error('Survey PDF generation failed:', err))
    }, 100)
  }

  const handleTextAreaChanged = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    if (!canEdit) return
    const { name, value } = e.target

    const updatedData = {
      ...formData,
      [name]: value,
    }

    setFormData(updatedData)

    if (saveTimeoutRef.current) {
      clearTimeout(saveTimeoutRef.current)
    }

    saveTimeoutRef.current = setTimeout(() => {
      autoSave(updatedData)
    }, 1000)
  }

  const handleSelectChanged = (e: React.ChangeEvent<HTMLSelectElement>) => {
    if (!canEdit) return
    const { name, value } = e.target

    const updatedData = {
      ...formData,
      [name]: value,
    }

    setFormData(updatedData)

    if (saveTimeoutRef.current) {
      clearTimeout(saveTimeoutRef.current)
    }

    saveTimeoutRef.current = setTimeout(() => {
      autoSave(updatedData)
    }, 1000)
  }
  useEffect(() => {
    return () => {
      if (saveTimeoutRef.current) {
        clearTimeout(saveTimeoutRef.current)
      }
    }
  }, [])

  const handleAddRepresentative = async () => {
    if (!canEdit) return
    if (!clientInfo?._id) return

    try {
      const newRep: RepresentativeNaturalPerson = {
        relation: '',
        name: '',
        firstName: '',
        address: '',
        country: '',
        birthPlace: '',
        birthDate: '',
        nationality: '',
        idNumber: '',
        authority: '',
        notes: '',
        lastCheck: new Date().toString(),
        numberChecks: 0,
        risk: false,
        isActive: true,
        personContractingParty: false,
      }

      const result = await addRepresentative(clientInfo._id, newRep)

      if (!result) {
        showKAlert('danger', 'Failed to add representative')
        return
      }
      const updatedData = await getClientInfo(clientId!)
      setClientInfo(updatedData)
    } catch (err: any) {
      console.error('Error adding representative:', err)
      showKAlert('danger', 'Failed to add representative')
    }
  }

  const handleRepresentativeChange = (key: string, field: string, value: string) => {
    if (!canEdit) return
    if (!clientInfo?._id) return

    setClientInfo(prev => {
      if (!prev) return prev
      return {
        ...prev,
        contractualPartner: {
          ...prev.contractualPartner,
          representatives: {
            ...prev.contractualPartner.representatives,
            [key]: {
              ...prev.contractualPartner.representatives[key],
              [field]: value,
            },
          },
        },
      }
    })

    if (saveTimeoutRef.current) {
      clearTimeout(saveTimeoutRef.current)
    }

    saveTimeoutRef.current = setTimeout(async () => {
      try {
        await updateRepresentative(clientInfo._id!, key, { [field]: value })
      } catch (err: any) {
        console.error('Error updating representative:', err)
      }
    }, 500)
  }

  const handleDeleteRepresentative = async (key: string) => {
    if (!canEdit) return
    if (!clientInfo?._id) return
    if (!window.confirm('Are you sure you want to delete this representative?')) return

    try {
      await deleteRepresentative(clientInfo._id, key)

      const updatedData = await getClientInfo(clientId!)
      setClientInfo(updatedData)
    } catch (err: any) {
      console.error('Error deleting representative:', err)
      showKAlert('danger', 'Failed to delete representative')
    }
  }

  const handleAddBeneficialOwner = async (type: string) => {
    if (!canEdit) return
    if (!clientInfo?._id) return

    try {
      const backendType =
        type === 'legalEntities'
          ? 'legalEntities'
          : type === 'foundations'
            ? 'foundationsLegalCapacity'
            : type === 'instigationPersons'
              ? 'instigationPersons'
              : 'legalEntities'

      const newOwner: BeneficialOwner = {
        type: backendType,
        isPerson: true,
        name: '',
        firstName: '',
        country: '',
        birthDate: '',
        nationality: '',
        idNumber: '',
        authority: '',
        identityVerificationThrough: '',
        notes: '',
        lastCheck: new Date().toString(),
        numberChecks: 0,
        risk: false,
      }

      const result = await addBeneficialOwner(clientInfo._id, newOwner)

      if (!result) {
        showKAlert('danger', 'Failed to add beneficial owner')
        return
      }

      const updatedData = await getClientInfo(clientId!)
      setClientInfo(updatedData)
    } catch (err: any) {
      console.error('Error adding beneficial owner:', err)
      alert('Failed to add beneficial owner')
    }
  }

  const handleBeneficialOwnerChange = (
    type: string,
    key: string,
    field: string,
    value: string | boolean
  ) => {
    if (!canEdit) return
    if (!clientInfo?._id) return
    const beneficialOwnersType:
      'legalEntities' | 'foundationsLegalCapacity' | 'instigationPersons' =
      type === 'legalEntities'
        ? 'legalEntities'
        : type === 'foundations'
          ? 'foundationsLegalCapacity'
          : type === 'instigationPersons'
            ? 'instigationPersons'
            : 'legalEntities'

    setClientInfo(prev => {
      if (!prev) return prev

      const currentOwners = prev.beneficialOwners[beneficialOwnersType] || {}
      const currentOwner = currentOwners[key] || {}

      return {
        ...prev,
        beneficialOwners: {
          ...prev.beneficialOwners,
          [beneficialOwnersType]: {
            ...currentOwners,
            [key]: {
              ...currentOwner,
              [field]: value,
            },
          },
        },
      }
    })

    if (saveTimeoutRef.current) {
      clearTimeout(saveTimeoutRef.current)
    }

    saveTimeoutRef.current = setTimeout(async () => {
      try {
        await updateBeneficialOwner(clientInfo._id!, key, {
          [field]: value,
          type: beneficialOwnersType,
        })
      } catch (err: any) {
        console.error('Error updating beneficial owner:', err)
      }
    }, 1000)
  }

  const handleDeleteBeneficialOwner = async (key: string, type: string) => {
    if (!canEdit) return
    if (!clientInfo?._id) return
    if (!window.confirm('Are you sure you want to delete this beneficial owner?')) return

    try {
      // Map frontend type to backend type
      const backendType =
        type === 'legalEntities'
          ? 'legalEntities'
          : type === 'foundations'
            ? 'foundationsLegalCapacity'
            : type === 'instigationPersons'
              ? 'instigationPersons'
              : 'legalEntities'

      await deleteBeneficialOwner(clientInfo._id, key, backendType)

      const updatedData = await getClientInfo(clientId!)
      setClientInfo(updatedData)
    } catch (err: any) {
      console.error('Error deleting beneficial owner:', err)
      showKAlert('danger', 'Failed to delete beneficial owner')
    }
  }

  const handleDateChange = async (field: string, date: Date | null) => {
    if (!canEdit) return
    const asString = formatDDMMYYYY(date)

    const nextForm = {
      ...formData,
      [field]: asString,
    }

    setFormData(nextForm)

    await autoSave(nextForm)
  }

  const getAccess = async () => {
    const result = await fetchAccess(localStorage.getItem('email'))

    if (!!result.accessToken) {
      setAccessToken(result.accessToken)
      setPin(result.pinCode)
      setPinRequired(result.pinRequired !== false)
      setAccess(true)
    }
  }

  const checkPin = async (pinCode: number) => {
    try {
      const result = await validatePinCode(pinCode)

      if (result?.userAccess) {
        setUserAccess(result.userAccess)
        setAccess(false)

        const response = await kycCheck()
        if (response) {
          setKycChecksNew(true)
        }
      }
    } catch (error) {
      console.error('Error validating pin code:', error)
    }
  }

  const kycCheck = async () => {
    try {
      setLoading(true)
      setError(null)

      const result = await performKycCheckOne({
        clientRepresentId: localStorage.getItem('representativeKey') ?? '',
        clientId: localStorage.getItem('clientId'),
        clientNumber: localStorage.getItem('clientNumber'),
        firstName: localStorage.getItem('firstName'),
        lastName: localStorage.getItem('name'),
        dateOfBirth: localStorage.getItem('dateOfBirth'),
        country: localStorage.getItem('country'),
        accessToken: getAccessToken() ?? '',
        companyInfo: getCompanyInfo(),
        clientInfo: true,
        clientInfoId: localStorage.getItem('clientInfoId') ?? '',
      })

      if (!result || result.length === 0) {
        showKAlert('warning', 'No results returned from KYC check')
        return null
      }

      clearKycCheckCache(formData.id)
      setKycChecks(result[0])
      setKycChecksNew(true)
      showKAlert('success', 'KYC check completed successfully')
      return result
    } catch (error: any) {
      console.error('Error performing KYC check:', error)
      showKAlert('danger', error.message || 'Failed to perform KYC check')
      setError(error.message || 'Failed to perform KYC check')
      return null
    } finally {
      setLoading(false)
    }
  }

  const getKycCheck = async (representativeKey: string) => {
    try {
      setLoading(true)
      setError(null)

      const response = await getKycCheckClientInfo(representativeKey)

      if (!response.ok) {
        throw new Error(response.message?.content || 'Failed to fetch KYC check data')
      }

      if (!response.result) {
        showKAlert('warning', 'No KYC check data found')
        return
      }

      setKycChecks(response.result)
      setKycChecksNew(true)
    } catch (error: any) {
      console.error('Error fetching KYC check:', error)
      showKAlert('danger', error.message || 'Failed to load KYC check data')
      setError(error.message || 'Failed to load KYC check data')
    } finally {
      setLoading(false)
    }
  }

  const createIdentityRequest = async () => {
    if (!canEdit) return
    const userAccess = sessionStorage.getItem('userAccess') ?? ''
    const userAccessParsed = JSON.parse(userAccess)

    try {
      const result = await createIdentityRequestService({
        service: 'identity',
        identityData: {
          gender: localStorage.getItem('gender'),
          firstName: localStorage.getItem('firstName'),
          name: localStorage.getItem('name'),
          dateOfBirth: '',
          email: localStorage.getItem('email'),
          createdAt: new Date(),
          status: 'assigned',
          clientId: localStorage.getItem('clientId'),
          subjectId: identitySubjectId,
          subjectType: identitySubjectType,
          companyId: sessionStorage.getItem('companyInfo'),
          requestEmail: userAccessParsed['email'],
        },
      })

      if (result?.error === 'no_credit') {
        showKAlert('danger', 'notEnoughCredit')
        setShowModalIdentity(false)
        return
      }

      if (result?.success && identitySubjectId) {
        setVariantIdentity(prev => ({
          ...prev,
          [identitySubjectId]: 'warning',
        }))
        await fetchIdentityStatusForSubject(identitySubjectId)
      }

      setShowModalIdentity(false)
    } catch (error) {
      showKAlert('danger', 'An unexpected error occurred. Please try again.')
    }
  }

  const fetchIdentityStatusForSubject = async (subjectId: string) => {
    try {
      const res = await fetchIdentityParams(clientId || null, subjectId)

      setIdentityRequests(prev => {
        if (!res?.identity) {
          const { [subjectId]: _, ...rest } = prev
          return rest
        }

        return {
          ...prev,
          [subjectId]: res.identity,
        }
      })

      setVariantIdentity(prev => ({
        ...prev,
        [subjectId]: res?.ok && res?.identity ? 'success' : res?.identity ? 'warning' : 'secondary',
      }))
    } catch (e) {
      setVariantIdentity(prev => ({
        ...prev,
        [subjectId]: 'secondary',
      }))

      setIdentityRequests(prev => {
        const { [subjectId]: _, ...rest } = prev
        return rest
      })
    }
  }

  useEffect(() => {
    if (!clientId) return

    const subjectIds = [
      ...Object.keys(representatives),
      ...Object.keys(beneficialOwnersLegalEntities),
    ]

    if (!subjectIds.length) return

    let cancelled = false

    const preloadIdentityStatuses = async () => {
      const results = await Promise.all(
        subjectIds.map(async subjectId => {
          try {
            const res = await fetchIdentityParams(clientId, subjectId)
            const variant: 'secondary' | 'success' | 'warning' | 'danger' =
              res?.ok && res?.identity ? 'success' : res?.identity ? 'warning' : 'secondary'

            return { subjectId, variant, identity: res?.identity || null }
          } catch {
            return { subjectId, variant: 'secondary' as const, identity: null }
          }
        })
      )

      if (cancelled) return

      setVariantIdentity(prev => {
        const next = { ...prev }
        results.forEach(({ subjectId, variant }) => {
          next[subjectId] = variant
        })
        return next
      })

      setIdentityRequests(prev => {
        const next = { ...prev }
        results.forEach(({ subjectId, identity }) => {
          if (identity) {
            next[subjectId] = identity
          } else {
            delete next[subjectId]
          }
        })
        return next
      })
    }

    preloadIdentityStatuses()

    return () => {
      cancelled = true
    }
  }, [clientId, representatives, beneficialOwnersLegalEntities])

  const openIdentityModal = async (
    subjectId: string,
    subjectType: 'client' | 'representative' | 'beneficialOwner'
  ) => {
    if (isPiiEncryptionEnabled()) {
      showKAlert('danger', t('serviceDisabledByPiiEncryption'))
      return
    }
    setIdentitySubjectId(subjectId)
    setIdentitySubjectType(subjectType)
    await fetchIdentityStatusForSubject(subjectId)
    setShowModalIdentity(true)
  }

  const removeIdentityRequest = async () => {
    if (!canEdit) return
    const subjectId = identitySubjectId
    const identity = identityRequests[subjectId]

    if (!identity) return

    const confirmed = window.confirm('Are you sure you want to remove the DS|Identity request?')
    if (!confirmed) return

    try {
      const result = await deleteIdentityRequestService({
        identityCompanyId: identity.identityCompanyId,
        identityRequestId: identity.identityRequestId,
        clientId: identity.clientId,
        subjectId: identity.subjectId || subjectId,
      })

      if (result?.success) {
        setVariantIdentity(prev => ({
          ...prev,
          [subjectId]: 'secondary',
        }))

        setIdentityRequests(prev => {
          const { [subjectId]: _, ...rest } = prev
          return rest
        })

        showKAlert('success', 'DS|Identity request removed.')
        setShowModalIdentity(false)
      } else {
        showKAlert('danger', 'Failed to remove DS|Identity request.')
      }
    } catch (error) {
      showKAlert('danger', 'Failed to remove DS|Identity request.')
    }
  }

  const fetchSurveyFiles = async (firmename: string) => {
    if (!clientId || !firmename) return
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/files/kyc/documents`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ clientId, firmename }),
      })
      const data = await res.json()
      setSurveyFiles((data.documents || []).filter((f: any) => f.type === 'survey_form'))
    } catch {}
  }

  const handleSurveyUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!canEdit) return
    const file = e.target.files?.[0]
    if (!file || !clientId || !client?.name) return
    const fd = new FormData()
    fd.append('clientId', clientId)
    fd.append('firmename', client.name)
    fd.append('type', 'survey_form')
    fd.append('file', file)
    setSurveyUploading(true)
    try {
      await fetch(`${process.env.REACT_APP_API_URL}/files/kyc/upload`, { method: 'POST', body: fd })
      await fetchSurveyFiles(client.name)
    } finally {
      setSurveyUploading(false)
      if (surveyFileInputRef.current) surveyFileInputRef.current.value = ''
    }
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (client?.name) fetchSurveyFiles(client.name)
  }, [client?.name, clientId])

  if (loading) {
    return (
      <Container>
        <div className='text-center mt-5'>Loading...</div>
      </Container>
    )
  }

  if (error) {
    return (
      <Container>
        <div className='alert alert-danger mt-5'>{error}</div>
      </Container>
    )
  }

  return (
    <>
      <Container>
        <Row>
          <div className='sidebar col-md-3 col-lg-2 p-0'>
            <KLayerNavigation logged={isUserLoggedIn()} />
          </div>
          <main
            className='col-md-14 col-lg-10'
            style={{ maxHeight: '100vh', overflowY: 'auto', paddingBottom: '20rem' }}
          >
            <fieldset
              ref={surveyPdfRef}
              disabled={!canEdit}
              className='border-0 p-0 m-0 survey-pdf'
              style={{ minWidth: 0 }}
            >
              {!canEdit && <div className='alert alert-info mt-3'>{t('readOnlyNoPermission')}</div>}
              <Row>
                <Col className='col-sm-9'>
                  <Card.Title>
                    <h5 className='text-draft'>{t(getDataSecurityCompanyName())}</h5>
                    <h4>{t('surveyForm')}</h4>
                  </Card.Title>
                  <hr />
                  <div className='mb-4'>
                    <b className=''>
                      {t('registerNumber')}: {client?.clientNumber}
                    </b>
                  </div>
                  {/* A 1 */}
                  <h5 className='fw-bold'>A. {t('contractualPartner')}</h5>
                  <div className='ms-4'>
                    <h6 className='fw-bold'>1. {t('identification')}</h6>
                    {/* a) */}
                    <div className='ms-4'>
                      <h5 className='fw-bold'>a) {t('establishingIdentity')}</h5>

                      {/* Already Identified Checkbox */}
                      <div className='form-check ms-4 mt-2'>
                        <input
                          id='dataCollected'
                          className='form-check-input'
                          type='checkbox'
                          name='dataCollected'
                          checked={formData.dataCollected}
                          onChange={handleInputChange}
                        />
                        <label className='form-check-label' htmlFor='dataCollected'>
                          &nbsp;{t('alreadyIdentified')}
                        </label>
                      </div>

                      {/* New Assessment Checkbox */}
                      <div className='form-check ms-4 mt-2'>
                        <input
                          id='newAssessment'
                          className='form-check-input'
                          type='checkbox'
                          name='newAssessment'
                          checked={formData.newAssessment}
                          onChange={handleInputChange}
                        />
                        <label className='form-check-label' htmlFor='newAssessment'>
                          &nbsp;{t('newAssessment')}
                        </label>
                      </div>

                      {/* Name */}
                      <div className='mt-2'>
                        <label htmlFor='name'>{t('Name')}</label>
                        <input
                          id='name'
                          className='form-control bg-info2'
                          type='text'
                          name='name'
                          value={formData.name}
                          onChange={handleInputChange}
                        />
                      </div>

                      {/* Name */}
                      <div className='mt-2'>
                        <label htmlFor='firstName'>{t('firstName')}</label>
                        <input
                          id='firstName'
                          className='form-control bg-info2'
                          type='text'
                          name='firstName'
                          value={formData.firstName}
                          onChange={handleInputChange}
                        />
                      </div>

                      {/* Address */}
                      <div className='mt-2'>
                        <label htmlFor='address' style={{ textTransform: 'none' }}>
                          {t('addressOfRegisteredOffice')}
                        </label>
                        <input
                          id='address'
                          className='form-control bg-info2'
                          type='text'
                          name='address'
                          value={formData.address}
                          onChange={handleInputChange}
                        />
                      </div>

                      <div className='mt-2'>
                        <label htmlFor='country'>{t('country')}</label>
                        <Form.Select
                          className='bg-info2 form-select-sm select.no-capitalize option '
                          id='country'
                          name='country'
                          value={formData.country}
                          onChange={handleSelectChanged}
                        >
                          <option label={t('--')}></option>
                          {countries.map(option => (
                            <option key={option.value} value={option.value}>
                              {t(option.label)}
                            </option>
                          ))}
                        </Form.Select>
                      </div>

                      <div className='mt-2'>
                        <label htmlFor='placeOfBirth'>{t('birthPlace')}</label>
                        <input
                          id='placeOfBirth'
                          className='form-control bg-info2'
                          type='text'
                          name='placeOfBirth'
                          value={formData.placeOfBirth}
                          onChange={handleInputChange}
                        />
                      </div>

                      <div className='mt-2'>
                        <label htmlFor='dateOfBirth'>{t('dateOfBirth')}</label>

                        <div className='date-picker-wrapper' style={{ position: 'relative' }}>
                          <Form.Control
                            type='text'
                            className='bg-info2'
                            placeholder='DD.MM.YYYY'
                            name='dateOfBirth'
                            value={formData.dateOfBirth || ''}
                            onClick={() => setDatePickerDateOfBirth(!datePickerDateOfBirth)}
                            onChange={handleInputChange}
                          />

                          {datePickerDateOfBirth && (
                            <div style={PICKER_DROPDOWN_STYLE}>
                              <DayPicker
                                mode='single'
                                selected={parseDDMMYYYY(formData.dateOfBirth) ?? undefined}
                                month={
                                  parseDDMMYYYY(formData.dateOfBirth) ?? dateOfBirthPickerMonth
                                }
                                onMonthChange={setDateOfBirthPickerMonth}
                                onSelect={(d: Date | undefined) => {
                                  handleDateChange('dateOfBirth', d ?? null)
                                  setDatePickerDateOfBirth(false)
                                }}
                                captionLayout='dropdown'
                                startMonth={new Date(1900, 0)}
                                endMonth={new Date()}
                              />
                            </div>
                          )}
                        </div>
                      </div>

                      <div className='mt-2'>
                        <label htmlFor='nationality'>{t('nationality')}</label>
                        <input
                          id='nationality'
                          className='form-control bg-info2'
                          type='text'
                          name='nationality'
                          value={formData.nationality}
                          onChange={handleInputChange}
                        />
                      </div>

                      <div className='mt-2'>
                        <label htmlFor='idNumber'>{t('idNumber')}</label>
                        <input
                          id='idNumber'
                          className='form-control bg-info2'
                          type='text'
                          name='idNumber'
                          value={formData.idNumber}
                          onChange={handleInputChange}
                        />
                      </div>

                      <div className='mt-2'>
                        <label htmlFor='authority'>{t('authority')}</label>
                        <input
                          id='authority'
                          className='form-control bg-info2'
                          type='text'
                          name='authority'
                          value={formData.authority}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>
                    {/* b) */}
                    <div className='ms-4 mt-4' style={{ position: 'relative', zIndex: 1 }}>
                      <h5>
                        <b> b) {t('identitVerificationContractualPartner')}</b>
                      </h5>
                      <h5 className='mt-3 fw-bold'>{t('identityHasBeenVerified')}</h5>
                      <div className='form-check mt-2'>
                        <input
                          id='idCardPassport'
                          className='form-check-input'
                          type='checkbox'
                          name='idCardPassport'
                          checked={formData.idCardPassport}
                          onChange={handleInputChange}
                        />
                        <label
                          className='form-check-label'
                          htmlFor='idCardPassport'
                          style={{ cursor: 'pointer' }}
                        >
                          &nbsp;{t('idCardPassport')}
                        </label>
                      </div>
                      <div className='form-check mt-2'>
                        <input
                          id='electronicIdProof'
                          className='form-check-input'
                          type='checkbox'
                          name='electronicIdProof'
                          checked={formData.electronicIdProof}
                          onChange={handleInputChange}
                        />
                        <label
                          className='form-check-label'
                          htmlFor='electronicIdProof'
                          style={{ cursor: 'pointer' }}
                        >
                          &nbsp;{t('electronicIdProof')}
                        </label>
                      </div>
                      <div className='form-check mt-2'>
                        <input
                          id='simplifiedDueDiligence'
                          className='form-check-input'
                          type='checkbox'
                          name='simplifiedDueDiligence'
                          checked={formData.simplifiedDueDiligence}
                          onChange={handleInputChange}
                        />
                        <label
                          className='form-check-label'
                          htmlFor='simplifiedDueDiligence'
                          style={{ cursor: 'pointer' }}
                        >
                          &nbsp;{t('simplifiedDueDiligence')}
                        </label>
                      </div>
                      <div className='form-check mt-2'>
                        <input
                          id='birthCertificateUnder16'
                          className='form-check-input'
                          type='checkbox'
                          name='birthCertificateUnder16'
                          checked={formData.birthCertificateUnder16}
                          onChange={handleInputChange}
                        />
                        <label
                          className='form-check-label'
                          htmlFor='birthCertificateUnder16'
                          style={{ cursor: 'pointer' }}
                        >
                          &nbsp;{t('birthCertificateUnder16')}
                        </label>
                      </div>
                      <div className='form-check mt-2'>
                        <input
                          id='guardianshipCertificate'
                          className='form-check-input'
                          type='checkbox'
                          name='guardianshipCertificate'
                          checked={formData.guardianshipCertificate}
                          onChange={handleInputChange}
                        />
                        <label
                          className='form-check-label'
                          htmlFor='guardianshipCertificate'
                          style={{ cursor: 'pointer' }}
                        >
                          &nbsp;{t('guardianshipCertificate')}
                        </label>
                      </div>
                    </div>
                    {/* A2 */}
                    <h5 className='mt-4 fw-bold'>2. {t('personActingContractualPartner')}</h5>
                    {/* a) */}
                    <div className='ms-4'>
                      <h5 className='fw-bold'>a) {t('identificationContractualPartner')}</h5>
                      {!hasRepresentatives ? (
                        <Button
                          className='btn btn-primary mt-2 mb-4'
                          size='sm'
                          onClick={handleAddRepresentative}
                        >
                          +
                        </Button>
                      ) : (
                        <>
                          {Object.entries(
                            representatives as Record<string, RepresentativeNaturalPerson>
                          ).map(([key, rep]) => (
                            <div key={key} className='mb-4'>
                              <div className='d-flex justify-content-between mb-2'>
                                <div className='mt-4'>
                                  <b>
                                    VNP-
                                    <span>{key.replace('representative-', '')}</span>
                                  </b>
                                  &nbsp;{t('representativeNaturalPerson')}
                                </div>
                                <KButton
                                  icon='trash'
                                  variant='danger'
                                  size='sm'
                                  onClick={() => handleDeleteRepresentative(key)}
                                />
                              </div>
                              <Row>
                                <Col md={12}>
                                  <div className='mb-2'>
                                    <select
                                      id='relation'
                                      className='form-control mt-2 bg-info2'
                                      value={rep.relation}
                                      onChange={e =>
                                        handleRepresentativeChange(key, 'relation', e.target.value)
                                      }
                                    >
                                      <option value='Beziehung'>{t('Beziehung')}</option>
                                      <option value='Eheähnlicher Lebenspartner'>
                                        {t('Eheähnlicher Lebenspartner')}
                                      </option>
                                      <option value='Ehefrau/Lebenspartner'>
                                        {t('Ehefrau/Lebenspartner')}
                                      </option>
                                      <option value='Gesetzlicher Vertreter der Person'>
                                        {t('Gesetzlicher Vertreter der Person')}
                                      </option>
                                      <option value='Vertretungsbevollmächtigter'>
                                        {t('Vertretungsbevollmächtigter')}
                                      </option>
                                      <option value='Mitwirkungsbevollmächtigter'>
                                        {t('Mitwirkungsbevollmächtigter')}
                                      </option>
                                      <option value='Empfangsbevollmächtigter'>
                                        {t('Empfangsbevollmächtigter')}
                                      </option>
                                      <option value='Partei kraft Amtes'>
                                        {t('Partei kraft Amtes')}
                                      </option>
                                    </select>
                                  </div>
                                </Col>
                                <Col md={12}>
                                  <div className='mb-2'>
                                    <input
                                      placeholder={t('lastName')}
                                      className='form-control form-control-sm bg-info2'
                                      type='text'
                                      value={rep.name}
                                      onChange={e =>
                                        handleRepresentativeChange(key, 'name', e.target.value)
                                      }
                                    />
                                  </div>
                                </Col>
                                <Col md={12}>
                                  <div className='mb-2'>
                                    <input
                                      placeholder={t('firstName')}
                                      className='form-control form-control-sm bg-info2'
                                      type='text'
                                      value={rep.firstName}
                                      onChange={e =>
                                        handleRepresentativeChange(key, 'firstName', e.target.value)
                                      }
                                    />
                                  </div>
                                </Col>
                                <Col md={12}>
                                  <div className='mb-2'>
                                    <input
                                      placeholder={t('address')}
                                      className='form-control form-control-sm bg-info2'
                                      type='text'
                                      value={rep.address}
                                      onChange={e =>
                                        handleRepresentativeChange(key, 'address', e.target.value)
                                      }
                                    />
                                  </div>
                                </Col>
                                <Col md={6}>
                                  <div className='mb-2'>
                                    <Form.Select
                                      className='bg-info2 form-select-sm'
                                      id='country'
                                      value={rep.country}
                                      onChange={e =>
                                        handleRepresentativeChange(key, 'country', e.target.value)
                                      }
                                    >
                                      <option label={t('country')}></option>
                                      {countries.map(option => (
                                        <option key={option.value} value={option.value}>
                                          {t(option.label)}
                                        </option>
                                      ))}
                                    </Form.Select>
                                  </div>
                                </Col>
                                <Col md={12}>
                                  <div className='mb-2'>
                                    <input
                                      placeholder={t('birthPlace')}
                                      className='form-control form-control-sm bg-info2'
                                      type='text'
                                      value={rep.birthPlace}
                                      onChange={e =>
                                        handleRepresentativeChange(
                                          key,
                                          'birthPlace',
                                          e.target.value
                                        )
                                      }
                                    />
                                  </div>
                                </Col>
                                <Col md={6}>
                                  <div
                                    className='mb-2 date-picker-wrapper'
                                    style={{ position: 'relative' }}
                                  >
                                    <Form.Control
                                      size='sm'
                                      className='bg-info2'
                                      placeholder={t('dateOfBirth')}
                                      type='text'
                                      value={rep.birthDate || ''}
                                      onClick={() =>
                                        setDatePickerRepresentativeBirthDate(prev => ({
                                          ...prev,
                                          [key]: true,
                                        }))
                                      }
                                      onChange={e =>
                                        handleRepresentativeChange(key, 'birthDate', e.target.value)
                                      }
                                    />

                                    {datePickerRepresentativeBirthDate[key] && (
                                      <div style={PICKER_DROPDOWN_STYLE}>
                                        <DayPicker
                                          mode='single'
                                          selected={parseDDMMYYYY(rep.birthDate) ?? undefined}
                                          month={
                                            parseDDMMYYYY(rep.birthDate) ??
                                            representativePickerMonth[key] ??
                                            new Date(2000, 0)
                                          }
                                          onMonthChange={month =>
                                            setRepresentativePickerMonth(prev => ({
                                              ...prev,
                                              [key]: month,
                                            }))
                                          }
                                          onSelect={date => {
                                            const formatted = formatDDMMYYYY(date ?? null)
                                            handleRepresentativeChange(key, 'birthDate', formatted)
                                            setDatePickerRepresentativeBirthDate(prev => ({
                                              ...prev,
                                              [key]: false,
                                            }))
                                          }}
                                          captionLayout='dropdown'
                                          startMonth={new Date(1900, 0)}
                                          endMonth={new Date()}
                                        />
                                      </div>
                                    )}
                                  </div>
                                </Col>
                                <Col md={12}>
                                  <div className='mb-2'>
                                    <input
                                      placeholder={t('nationality')}
                                      className='form-control form-control-sm bg-info2'
                                      type='text'
                                      value={rep.nationality}
                                      onChange={e =>
                                        handleRepresentativeChange(
                                          key,
                                          'nationality',
                                          e.target.value
                                        )
                                      }
                                    />
                                  </div>
                                </Col>
                                <Col md={12}>
                                  <div className='mb-2'>
                                    <input
                                      placeholder={t('idNumber')}
                                      className='form-control form-control-sm bg-info2'
                                      type='text'
                                      value={rep.idNumber}
                                      onChange={e =>
                                        handleRepresentativeChange(key, 'idNumber', e.target.value)
                                      }
                                    />
                                  </div>
                                </Col>
                                <Col md={12}>
                                  <div className='mb-2'>
                                    <input
                                      placeholder={t('authority')}
                                      className='form-control form-control-sm bg-info2'
                                      type='text'
                                      value={rep.authority}
                                      onChange={e =>
                                        handleRepresentativeChange(key, 'authority', e.target.value)
                                      }
                                    />
                                  </div>
                                </Col>
                                <Col>
                                  <KButton
                                    className='btn-user-primary btn-sm bg-collapse'
                                    icon='justify'
                                    title={t('notes')}
                                    onClick={() => {
                                      setShowModal(true)
                                    }}
                                  />
                                  <KButton
                                    className='btn-user-primary btn-sm btn-spacing bg-collapse'
                                    icon='eye'
                                    title={t('view')}
                                    onClick={() => {
                                      getKycCheck(key)
                                    }}
                                  />
                                  <KButton
                                    id='shufaCheck'
                                    variant={getKycCheckVariant(rep.lastCheck, rep.risk)}
                                    type='button'
                                    icon='check'
                                    className='text-white btn-spacing'
                                    title={t('ds | kyc check')}
                                    onClick={() => {
                                      localStorage.setItem('representativeKey', key)
                                      localStorage.setItem('clientInfoId', formData.id)
                                      localStorage.setItem('clientId', clientId || '')
                                      localStorage.setItem('name', rep.name)
                                      localStorage.setItem('firstName', rep.firstName)
                                      localStorage.setItem('country', rep.country)
                                      localStorage.setItem('dateOfBirth', rep.birthDate ?? '')
                                      getAccess()
                                    }}
                                  ></KButton>
                                  <KButton
                                    variant={variantIdentity[key] || 'secondary'}
                                    className='text-white btn-spacing'
                                    icon='person-bounding-box'
                                    title={t('DS | Identity')}
                                    onClick={() => {
                                      localStorage.setItem('name', rep.name)
                                      localStorage.setItem('firstName', rep.firstName)
                                      localStorage.setItem('country', rep.country)
                                      localStorage.setItem('clientId', clientId || '')
                                      openIdentityModal(key, 'representative')
                                    }}
                                  />
                                  <KButton
                                    className='btn-user-primary btn-sm btn-spacing bg-collapse'
                                    icon='folder2-open'
                                    title={t('documents')}
                                    onClick={() => {
                                      navigate(
                                        `/client/identity-documents/${clientId}/representative/${key}`
                                      )
                                    }}
                                  />
                                </Col>
                                <Modal
                                  id='noticeModal'
                                  show={showModal}
                                  onHide={() => setShowModal(false)}
                                >
                                  <Modal.Header closeButton className='bg-secondary'>
                                    <Modal.Title>{t('notice')}</Modal.Title>
                                  </Modal.Header>
                                  <Modal.Body>
                                    <textarea
                                      className='notice mt-3 bg-info2 w-100'
                                      placeholder={t('notice')}
                                      value={rep.notes}
                                      onChange={e =>
                                        handleRepresentativeChange(key, 'notes', e.target.value)
                                      }
                                    />
                                  </Modal.Body>
                                  <Modal.Footer>
                                    <Button variant='secondary' onClick={() => setShowModal(false)}>
                                      {t('close') || 'Close'}
                                    </Button>
                                  </Modal.Footer>
                                </Modal>
                              </Row>
                            </div>
                          ))}

                          <Button
                            className='btn btn-primary mt-2'
                            size='sm'
                            onClick={handleAddRepresentative}
                          >
                            +
                          </Button>
                        </>
                      )}
                    </div>

                    {/* b) */}
                    <div className='ms-4 mt-4'>
                      <h5 className='fw-bold'>b) {t('identityVerification')}</h5>
                      <h5 className='fw-bold'> {t('identityHasBeenVerified')}</h5>
                      <div className='form-check mt-2'>
                        <input
                          id='idProof'
                          className='form-check-input'
                          type='checkbox'
                          name='idProof'
                          checked={formData.idProof}
                          onChange={handleInputChange}
                        />
                        <label
                          className='form-check-label'
                          htmlFor='idProof'
                          style={{ cursor: 'pointer' }}
                        >
                          &nbsp;{t('idProof')}
                        </label>
                      </div>
                      <div className='form-check mt-2'>
                        <input
                          id='electronicIdentityProof'
                          className='form-check-input'
                          type='checkbox'
                          name='electronicIdentityProof'
                          checked={formData.electronicIdentityProof}
                          onChange={handleInputChange}
                        />
                        <label
                          className='form-check-label'
                          htmlFor='electronicIdentityProof'
                          style={{ cursor: 'pointer' }}
                        >
                          &nbsp;{t('electronicIdentityProof')}
                        </label>
                      </div>
                      <div className='form-check mt-2'>
                        <input
                          id='otherProof'
                          className='form-check-input'
                          type='checkbox'
                          name='otherProof'
                          checked={formData.otherProof}
                          onChange={handleInputChange}
                        />
                        <label
                          className='form-check-label'
                          htmlFor='ownDootherProofcumented'
                          style={{ cursor: 'pointer' }}
                        >
                          &nbsp;{t('otherProof')}
                        </label>
                      </div>
                    </div>

                    {/* c) */}
                    <div className='ms-4 mt-4'>
                      <h5 className='fw-bold'> c) {t('authorizationVerifiedBy')}</h5>

                      <div className='ms-4'>
                        <textarea
                          className='w-100 bg-info2'
                          id='authorizationVerifiedBy'
                          name='authorizationVerifiedBy'
                          value={formData.authorizationVerifiedBy}
                          onChange={handleTextAreaChanged}
                        />
                      </div>
                    </div>
                  </div>
                  <h5 className='mt-4 fw-bold'>B. {t('identificationBeneficialOwners')}</h5>
                  {/* B 1 */}
                  <div className='ms-4'>
                    <h5 className='fw-bold'>
                      1. {t('identityEstablishmentAndIdentityVerification')}
                    </h5>

                    <div className='ms-4 mt-3 mb-3'>
                      <div className='form-check' style={{ position: 'relative', zIndex: 1 }}>
                        <input
                          className='form-check-input'
                          type='checkbox'
                          name='beneficialOwnersExist'
                          id='noBeneficialOwners'
                          checked={!hasBeneficialOwnersLegalEntities}
                          readOnly
                        />
                        <label
                          className='form-check-label'
                          htmlFor='noBeneficialOwners'
                          style={{ cursor: 'pointer' }}
                        >
                          {t('noBeneficialOwners1')}
                        </label>
                      </div>
                      <div className='form-check mt-2' style={{ position: 'relative', zIndex: 1 }}>
                        <input
                          className='form-check-input'
                          type='checkbox'
                          name='beneficialOwnersExist'
                          id='hasBeneficialOwners'
                          checked={hasBeneficialOwnersLegalEntities}
                          readOnly
                        />
                        <label
                          className='form-check-label'
                          htmlFor='hasBeneficialOwners'
                          style={{ cursor: 'pointer' }}
                        >
                          {t('hasBeneficialOwners1')}
                        </label>
                      </div>
                    </div>

                    <div>
                      {!hasBeneficialOwnersLegalEntities ? (
                        <KButton
                          variant='primary'
                          icon='plus'
                          onClick={() => handleAddBeneficialOwner('legalEntities')}
                        />
                      ) : (
                        <>
                          {Object.entries(
                            beneficialOwnersLegalEntities as Record<string, BeneficialOwner>
                          ).map(([key, rep]) => (
                            <div key={key} className='mb-4'>
                              <div className='d-flex justify-content-between mb-2'>
                                <div className='mt-4'>
                                  <b>
                                    {t('beneficialOwner')}-
                                    <span>{key.replace('beneficial-owner-', '')}</span>
                                  </b>
                                  &nbsp;{t('representativeNaturalPerson')}
                                </div>
                                <KButton
                                  icon='trash'
                                  variant='danger'
                                  size='sm'
                                  onClick={() => handleDeleteBeneficialOwner(key, 'legalEntities')}
                                />
                              </div>
                              <Row>
                                <Col md={6}>
                                  <div className='mb-2'>
                                    <label className='form-label' htmlFor='isPerson'>
                                      {t('naturalPerson')}
                                    </label>
                                    &nbsp;
                                    <input
                                      id='isPerson'
                                      className='form-check-input'
                                      type='checkbox'
                                      name='isPerson'
                                      checked={rep.isPerson}
                                      onChange={e =>
                                        handleBeneficialOwnerChange(
                                          'legalEntities',
                                          key,
                                          'isPerson',
                                          e.target.value
                                        )
                                      }
                                    />
                                  </div>
                                </Col>
                                <Col md={12}>
                                  <div className='mb-2'>
                                    <input
                                      placeholder={t('name')}
                                      className='form-control form-control-sm bg-info2'
                                      type='text'
                                      value={rep.name}
                                      onChange={e =>
                                        handleBeneficialOwnerChange(
                                          'legalEntities',
                                          key,
                                          'name',
                                          e.target.value
                                        )
                                      }
                                    />
                                  </div>
                                </Col>
                                <Col md={12}>
                                  <div className='mb-2'>
                                    <input
                                      placeholder={t('firstName')}
                                      className='form-control form-control-sm bg-info2'
                                      type='text'
                                      value={rep.firstName}
                                      onChange={e =>
                                        handleBeneficialOwnerChange(
                                          'legalEntities',
                                          key,
                                          'firstName',
                                          e.target.value
                                        )
                                      }
                                    />
                                  </div>
                                </Col>
                                <Col md={12}>
                                  <div className='mb-2'>
                                    <Form.Select
                                      className='bg-info2 form-select-sm'
                                      value={rep.country}
                                      onChange={e =>
                                        handleBeneficialOwnerChange(
                                          'legalEntities',
                                          key,
                                          'country',
                                          e.target.value
                                        )
                                      }
                                    >
                                      <option label={t('country')}></option>
                                      {countries.map(option => (
                                        <option key={option.value} value={option.value}>
                                          {t(option.label)}
                                        </option>
                                      ))}
                                    </Form.Select>
                                  </div>
                                </Col>
                                <Col md={6}>
                                  <div
                                    className='mb-2 date-picker-wrapper'
                                    style={{ position: 'relative' }}
                                  >
                                    <Form.Control
                                      className='bg-info2'
                                      placeholder={t('dateOfBirth')}
                                      type='text'
                                      value={rep.birthDate || ''}
                                      onClick={() =>
                                        setDatePickerBeneficialLegalBirthDate(prev => ({
                                          ...prev,
                                          [key]: true,
                                        }))
                                      }
                                      onChange={e =>
                                        handleBeneficialOwnerChange(
                                          'legalEntities',
                                          key,
                                          'birthDate',
                                          e.target.value
                                        )
                                      }
                                    />

                                    {datePickerBeneficialLegalBirthDate[key] && (
                                      <div style={PICKER_DROPDOWN_STYLE}>
                                        <DayPicker
                                          mode='single'
                                          selected={parseDDMMYYYY(rep.birthDate) ?? undefined}
                                          month={
                                            parseDDMMYYYY(rep.birthDate) ??
                                            beneficialPickerMonth[key] ??
                                            new Date(2000, 0)
                                          }
                                          onMonthChange={month =>
                                            setBeneficialPickerMonth(prev => ({
                                              ...prev,
                                              [key]: month,
                                            }))
                                          }
                                          onSelect={date => {
                                            const formatted = formatDDMMYYYY(date ?? null)
                                            handleBeneficialOwnerChange(
                                              'legalEntities',
                                              key,
                                              'birthDate',
                                              formatted
                                            )
                                            setDatePickerBeneficialLegalBirthDate(prev => ({
                                              ...prev,
                                              [key]: false,
                                            }))
                                          }}
                                          captionLayout='dropdown'
                                          startMonth={new Date(1900, 0)}
                                          endMonth={new Date()}
                                        />
                                      </div>
                                    )}
                                  </div>
                                </Col>
                                <Col md={12}>
                                  <div className='mb-2'>
                                    <input
                                      placeholder={t('nationality')}
                                      className='form-control form-control-sm bg-info2'
                                      type='text'
                                      value={rep.nationality}
                                      onChange={e =>
                                        handleBeneficialOwnerChange(
                                          'legalEntities',
                                          key,
                                          'nationality',
                                          e.target.value
                                        )
                                      }
                                    />
                                  </div>
                                </Col>
                                <Col md={12}>
                                  <div className='mb-2'>
                                    <input
                                      placeholder={t('idNumber')}
                                      className='form-control form-control-sm bg-info2'
                                      type='text'
                                      value={rep.idNumber}
                                      onChange={e =>
                                        handleBeneficialOwnerChange(
                                          'legalEntities',
                                          key,
                                          'idNumber',
                                          e.target.value
                                        )
                                      }
                                    />
                                  </div>
                                </Col>
                                <Col md={12}>
                                  <div className='mb-2'>
                                    <input
                                      placeholder={t('authority')}
                                      className='form-control form-control-sm bg-info2'
                                      type='text'
                                      value={rep.authority}
                                      onChange={e =>
                                        handleBeneficialOwnerChange(
                                          'legalEntities',
                                          key,
                                          'authority',
                                          e.target.value
                                        )
                                      }
                                    />
                                  </div>
                                </Col>
                                <Col md={12}>
                                  <div className='mb-2'>
                                    <input
                                      placeholder={t('identityVerificationThrough')}
                                      className='form-control form-control-sm bg-info2'
                                      type='text'
                                      value={rep.identityVerificationThrough}
                                      onChange={e =>
                                        handleBeneficialOwnerChange(
                                          'legalEntities',
                                          key,
                                          'identityVerificationThrough',
                                          e.target.value
                                        )
                                      }
                                    />
                                  </div>
                                </Col>
                                <Col>
                                  <KButton
                                    className='btn-user-primary btn-sm bg-collapse'
                                    icon='justify'
                                    title={t('notes')}
                                    onClick={() => {
                                      setShowModal(true)
                                    }}
                                  />
                                  <KButton
                                    className='btn-user-primary btn-sm btn-spacing bg-collapse'
                                    icon='eye'
                                    title={t('view')}
                                    onClick={() => {
                                      getKycCheck(key)
                                    }}
                                  />
                                  <KButton
                                    id='shufaCheck'
                                    variant={getKycCheckVariant(rep.lastCheck, rep.risk)}
                                    type='button'
                                    icon='check'
                                    className='text-white btn-spacing'
                                    title={t('ds | kyc check')}
                                    onClick={() => {
                                      localStorage.setItem('representativeKey', key)
                                      localStorage.setItem('clientInfoId', formData.id)
                                      localStorage.setItem('clientId', clientId || '')
                                      localStorage.setItem('name', rep.name)
                                      localStorage.setItem('firstName', rep.firstName)
                                      localStorage.setItem('country', rep.country)
                                      localStorage.setItem('dateOfBirth', rep.birthDate ?? '')
                                      getAccess()
                                    }}
                                  ></KButton>
                                  <KButton
                                    variant={variantIdentity[key] || 'secondary'}
                                    className='text-white btn-spacing'
                                    icon='person-bounding-box'
                                    title={t('DS | Identity')}
                                    onClick={() => {
                                      localStorage.setItem('name', rep.name)
                                      localStorage.setItem('firstName', rep.firstName)
                                      localStorage.setItem('country', rep.country)
                                      localStorage.setItem('clientId', clientId || '')
                                      openIdentityModal(key, 'beneficialOwner')
                                    }}
                                  />
                                  <KButton
                                    className='btn-user-primary btn-sm btn-spacing bg-collapse'
                                    icon='folder2-open'
                                    title={t('documents')}
                                    onClick={() => {
                                      navigate(
                                        `/client/identity-documents/${clientId}/beneficialOwner/${key}`
                                      )
                                    }}
                                  />
                                  <Modal
                                    id='noticeModal'
                                    show={showModal}
                                    onHide={() => setShowModal(false)}
                                  >
                                    <Modal.Header closeButton className='bg-secondary'>
                                      <Modal.Title>{t('notice')}</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                      <textarea
                                        className='notice mt-3 bg-info2 w-100'
                                        placeholder={t('notice')}
                                        value={rep.notes}
                                        onChange={e =>
                                          handleBeneficialOwnerChange(
                                            'legalEntities',
                                            key,
                                            'notes',
                                            e.target.value
                                          )
                                        }
                                      />
                                    </Modal.Body>
                                    <Modal.Footer>
                                      <Button
                                        variant='secondary'
                                        onClick={() => setShowModal(false)}
                                      >
                                        {t('close') || 'Close'}
                                      </Button>
                                    </Modal.Footer>
                                  </Modal>
                                </Col>
                              </Row>
                            </div>
                          ))}
                          <KButton
                            variant='primary'
                            icon='plus'
                            onClick={() => handleAddBeneficialOwner('legalEntities')}
                          />
                          {/* TODO Isto ako za legal entities uraditi i za foundationsLegalCapacity i instigationPersons */}
                        </>
                      )}
                    </div>
                  </div>

                  {/* C */}
                  <h5 className='mt-4 fw-bold'>C. {t('politicallyExposedPersons')}</h5>
                  <div className='mb-2 form-check'>
                    <input
                      id='noOneConnected'
                      className='form-check-input'
                      type='checkbox'
                      name='noOneConnected'
                      checked={formData.noOneConnected}
                      onChange={handleInputChange}
                    />
                    <label htmlFor='noOneConnected'>{t('noOneConnected')}</label>&nbsp;
                  </div>

                  <div className='mb-2 form-check'>
                    <input
                      id='closeToPolitically'
                      className='form-check-input'
                      type='checkbox'
                      name='closeToPolitically'
                      checked={formData.closeToPolitically}
                      onChange={handleInputChange}
                    />
                    <label htmlFor='closeToPolitically'>{t('closeToPolitically')}</label>&nbsp;
                  </div>
                  <div className='mb-2'>
                    <div className='ms-4 mt-2'>
                      <span> {t('preciseDesignation')}</span>
                    </div>
                    <div className='ms-4'>
                      <textarea
                        className='w-100 bg-info2'
                        id='preciseDesignation'
                        name='preciseDesignation'
                        value={formData.preciseDesignation}
                        onChange={handleTextAreaChanged}
                      />
                    </div>
                  </div>
                  {/* D. */}
                  <h5 className='mt-4 fw-bold'>D. {t('highRiskCountries')}</h5>
                  <div className='mb-2 form-check'>
                    <input
                      id='notEstablishedInHighRiskCountry'
                      className='form-check-input'
                      type='checkbox'
                      name='notEstablishedInHighRiskCountry'
                      checked={formData.notEstablishedInHighRiskCountry || false}
                      onChange={e => {
                        setFormData(prev => ({
                          ...prev,
                          notEstablishedInHighRiskCountry: e.target.checked,
                          establishedInHighRiskCountry: e.target.checked
                            ? false
                            : prev.establishedInHighRiskCountry,
                        }))
                      }}
                    />
                    <label htmlFor='notEstablishedInHighRiskCountry' style={{ cursor: 'pointer' }}>
                      {t('notEstablishedInHighRiskCountry')}
                    </label>
                    &nbsp;
                  </div>
                  <div className='mb-2 form-check'>
                    <input
                      id='establishedInHighRiskCountry'
                      className='form-check-input'
                      type='checkbox'
                      name='establishedInHighRiskCountry'
                      checked={formData.establishedInHighRiskCountry || false}
                      onChange={e => {
                        setFormData(prev => ({
                          ...prev,
                          establishedInHighRiskCountry: e.target.checked,
                          notEstablishedInHighRiskCountry: e.target.checked
                            ? false
                            : prev.notEstablishedInHighRiskCountry,
                        }))
                      }}
                      disabled={formData.notEstablishedInHighRiskCountry}
                      style={{
                        opacity: formData.notEstablishedInHighRiskCountry ? 0.5 : 1,
                        cursor: formData.notEstablishedInHighRiskCountry
                          ? 'not-allowed'
                          : 'pointer',
                      }}
                    />
                    <label htmlFor='establishedInHighRiskCountry'>
                      {t('establishedInHighRiskCountry')}
                    </label>
                    &nbsp;
                  </div>
                  <div className='mb-2'>
                    <div className='ms-4 mt-2'>
                      <span> {t('thirdCountry')}</span>
                    </div>
                    <div className='ms-4'>
                      <textarea
                        className='w-100 bg-info2'
                        id='thirdCountry'
                        name='thirdCountry'
                        value={formData.thirdCountry}
                      />
                    </div>
                  </div>
                  <h5 className='mt-4'>E. {t('informationOnTheBusinessRelationship')}</h5>
                  <div className='mb-2 form-check'>
                    <input
                      id='purposeAndNatureClear'
                      className='form-check-input'
                      type='checkbox'
                      name='purposeAndNatureClear'
                      checked={formData.purposeAndNatureClear}
                      onChange={e => {
                        const updated = {
                          ...formData,
                          purposeAndNatureClear: e.target.checked,
                          purposeAndNatureDescription: e.target.checked
                            ? false
                            : formData.purposeAndNatureDescription,
                        }
                        setFormData(updated)
                        if (saveTimeoutRef.current) clearTimeout(saveTimeoutRef.current)
                        saveTimeoutRef.current = setTimeout(() => autoSave(updated), 600)
                      }}
                    />
                    <label htmlFor='purposeAndNatureClear'>{t('purposeAndNatureClear')}</label>
                    &nbsp;
                  </div>
                  <div className='mb-2 form-check'>
                    <input
                      id='purposeAndNatureDescription'
                      className='form-check-input'
                      type='checkbox'
                      name='purposeAndNatureDescription'
                      checked={formData.purposeAndNatureDescription}
                      onChange={e => {
                        const updated = {
                          ...formData,
                          purposeAndNatureDescription: e.target.checked,
                          purposeAndNatureClear: e.target.checked
                            ? false
                            : formData.purposeAndNatureClear,
                        }
                        setFormData(updated)
                        if (saveTimeoutRef.current) clearTimeout(saveTimeoutRef.current)
                        saveTimeoutRef.current = setTimeout(() => autoSave(updated), 600)
                      }}
                    />
                    <label htmlFor='purposeAndNatureDescription'>
                      {t('purposeAndNatureDescription')}
                    </label>
                    &nbsp;
                  </div>
                  <div className='mb-2'>
                    <div className='ms-4'>
                      <textarea
                        className='w-100 bg-info2'
                        id='purposeFurtherInfo'
                        name='purposeFurtherInfo'
                        value={formData.purposeFurtherInfo}
                        onChange={handleTextAreaChanged}
                      />
                    </div>
                  </div>
                  <h5 className='mt-4'>F. {t('furtherInformation')}</h5>
                  <div className='mb-2'>
                    <div className='ms-4'>
                      <textarea
                        className='w-100 bg-info2'
                        id='furtherInfo'
                        name='furtherInfo'
                        value={formData.furtherInfo}
                        onChange={handleTextAreaChanged}
                      />
                    </div>
                  </div>
                </Col>
              </Row>

              <Row className='mt-4'>
                <Col>
                  <h5 className='fw-bold'>{t('surveyFiles')}</h5>
                  <div className='mt-2 no-print'>
                    <input
                      ref={surveyFileInputRef}
                      type='file'
                      accept='.pdf,.txt,.xlsx,.doc,.docx'
                      className='d-none'
                      onChange={handleSurveyUpload}
                    />
                    <Button
                      variant='outline-primary'
                      size='sm'
                      disabled={surveyUploading}
                      onClick={() => surveyFileInputRef.current?.click()}
                    >
                      <i className='bi bi-upload me-1'></i>
                      {surveyUploading ? '...' : t('chooseFile')}
                    </Button>
                  </div>
                  {surveyFiles.length > 0 && (
                    <div className='mt-3'>
                      {surveyFiles.map((file, idx) => (
                        <div key={idx} className='d-flex align-items-center gap-2 mb-2'>
                          <span>{file.name}</span>
                          <Button
                            variant='outline-primary'
                            size='sm'
                            onClick={() =>
                              downloadKycFile(
                                clientId || '',
                                client?.name || '',
                                'survey_form',
                                file.name
                              )
                            }
                          >
                            <i className='bi bi-download'></i>
                          </Button>
                        </div>
                      ))}
                    </div>
                  )}
                </Col>
              </Row>

              <Row className='mt-4 mb-2 no-print'>
                <Col>
                  <div className='form-check form-switch'>
                    <input
                      id='isFinished'
                      className='form-check-input'
                      type='checkbox'
                      role='switch'
                      name='isFinished'
                      checked={formData.isFinished}
                      onChange={handleInputChange}
                    />
                    <label className='form-check-label fw-bold' htmlFor='isFinished'>
                      {t('surveyFormFinished')}
                    </label>
                  </div>
                </Col>
              </Row>
            </fieldset>

            {formData.isFinished && (
              <Row className='mt-2 mb-5 no-print'>
                <Col>
                  <Button variant='primary' onClick={handleGeneratePdf}>
                    <i className='bi bi-file-earmark-pdf me-2' />
                    {t('exportPDF')}
                  </Button>
                </Col>
              </Row>
            )}

            {access && (
              <KAccess
                show={access}
                pin={pin}
                pinRequired={pinRequired}
                onConfirm={(pin: any) => {
                  checkPin(pin)
                }}
                onClose={() => setAccess(false)}
                title={pinRequired ? t('pinCodeSent') : t('confirmAction')}
              />
            )}
            {kycChecksNew && (
              <KycCkecks
                show={true}
                kyc={kycChecks}
                onClose={() => setKycChecksNew(false)}
                onDelete={
                  (kycNumber: number) => {}
                  // kycCheckDelete(kycNumber)
                }
              />
            )}
            {showModalIdentity && (
              <div className='App'>
                <IdentityModal
                  show={showModalIdentity}
                  onClose={() => {
                    setShowModalIdentity(false)
                  }}
                  onAccept={createIdentityRequest}
                  onDelete={removeIdentityRequest}
                  existingIdentity={identityRequests[identitySubjectId]}
                />
              </div>
            )}
          </main>
        </Row>
      </Container>
    </>
  )
}
